export class ContractCancel {

    countryContractId!: string;
    incurredMonths!: number;
    informedKm!: number;
    indexTax!: number;
    adminTax!: number;
    cancelledTotalValue!: number;
    cancelledFordValue!: number;
    cancelledDealerValue!: number;
    operationContractId!: string;
    createDate!: Date;
    createUser!: string;
    updateDate!: Date;
    updateUser!: string;
    cancellationReason!: string;
    initialKm!: number;
    finalKm!: number;
    cancellationRemarks!: string;
    cancelledByTimeValue!: number;
    cancelledByKmValue!: number;
    cancellationType!: string;
    vin!: string;
    productId!: number;
    contractId!: number;
    reimbursedValue!: number;
    cancelDate!: Date;
    eventCode!: number;
    dealerCode!: string;
    kilometers!: number;
    remarks!: string;
    productCode!: string;
    dealerEmail!: string;
    sellerEmail!: string;
    sellerCode!: string;
}